window.gsap.registerPlugin(window.ScrollTrigger);

class VideoModule extends HTMLElement {
  constructor() {
    super();
    this.initializeElements();
  }

  initializeElements() {
    this.video = this.querySelector('div[video] video');
    this.poster = this.querySelector('div[poster] video');
    this.button_play = this.querySelector('button[play]');
    this.button_close = this.querySelector('button[close]');
  }

  connectedCallback() {
    document.addEventListener('DOMContentLoaded', this.gsap.bind(this));
    this.setupIntersectionObserver();
    this.setupButtons();
  }

  setupIntersectionObserver() {
    const observer = new IntersectionObserver(this.handleIntersection.bind(this), {
      root: null,
      threshold: 0.5,
    });
    observer.observe(this);
  }

  handleIntersection(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        this.activateModule();
      } else {
        this.deactivateModule();
      }
    });
  }

  activateModule() {
    this.setAttribute('data-active', true);
  }

  deactivateModule() {
    document.body.classList.remove('scroll_trigger_active');
    document.getElementById('sticky-add-to-cart').classList.remove('disabled');

    this.setAttribute('data-active', false);
    this.setAttribute('data-play', false);

    if (this.poster) {
      this.poster.play();
    }

    setTimeout(() => {
      this.video.pause();
      this.video.currentTime = 0;
    }, 700);
  }

  setupButtons() {
    this.button_play.addEventListener('click', this.handlePlayButtonClick.bind(this));
    this.button_close.addEventListener('click', this.handleCloseButtonClick.bind(this));
  }

  handlePlayButtonClick() {
    document.body.classList.add('scroll_trigger_active');
    document.getElementById('sticky-add-to-cart').classList.add('disabled');

    this.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
      inline: 'center',
    });

    this.setAttribute('data-play', true);

    this.video.play();

    if (this.poster) {
      setTimeout(() => {
        this.poster.pause();
      }, 700);
    }
  }

  handleCloseButtonClick() {
    document.body.classList.remove('scroll_trigger_active');
    document.getElementById('sticky-add-to-cart').classList.remove('disabled');

    this.setAttribute('data-play', false);

    if (this.poster) {
      this.poster.play();
    }

    setTimeout(() => {
      this.video.pause();
      this.video.currentTime = 0;
    }, 700);
  }

  gsap() {
    gsap.fromTo(
      this,
      {
        opacity: 0,
        xPercent: 0,
        yPercent: 25,
        scale: 0.75,
      },
      {
        opacity: 1,
        xPercent: 0,
        yPercent: 0,
        scale: 1,
        ease: 'expo.out',
        duration: 1.25,
        scrollTrigger: {
          trigger: this.parentElement,
          once: true,
          start: 'top 70%',
        },
      },
    );
  }
}

customElements.define('video-module', VideoModule);
